import { ListChecks } from 'lucide-react';
import { PantallaReporte } from '@components/PantallaReporte';
import { ReportePadronFiltros } from '@components/ReportePadronFiltros';
import { ReportePadronTabla } from '@components/ReportePadronTabla';
import {
  REPORTE_PADRON_PAGE_SIZE,
  getReportePadron,
  type ReportePadronParams,
  type ReportePadronRow,
} from '@lib/services/reportePadron';

/**
 * Reporte de padrón (VEN-512): el estado de cada persona cargada —titular y
 * familiares— para que la organización siga sus casos. Solo lectura, filtrable
 * por fecha de carga, DNI y estado; la organización ve solo la suya (el server
 * la acota). Misma pantalla que el Reporte ABM Web (`PantallaReporte`).
 */
export function ReportePadronPage() {
  return (
    <PantallaReporte<ReportePadronParams, ReportePadronRow>
      titulo="Reporte de padrón"
      descripcion="Estado de cada persona cargada, filtrado por fecha de carga, DNI y estado. Solo lectura."
      icono={<ListChecks size={22} style={{ color: 'var(--color-primary-darker)' }} />}
      clave="reporte-padron"
      obtener={getReportePadron}
      pageSize={REPORTE_PADRON_PAGE_SIZE}
      filtros={(buscar, loading) => <ReportePadronFiltros onBuscar={buscar} loading={loading} />}
      tabla={(rows, loading) => <ReportePadronTabla rows={rows} loading={loading} />}
    />
  );
}
